const statusCode = [400,401,402,403,404,405,406,407,408,409,410,411,412,413,
    414,415,416,417,418,421,422,424,429,500,501,502,503,504,505]

// Return true if the received status code matches the list, and false if it doesn't 
export const handleStatusCode = (code) => {
    return statusCode.includes(code);
}